module.exports = __webpack_public_path__ + "static/media/Roasted_Pepper.5805ba7b.webp";